import { SportCenterPolicy, TermsTypeOption } from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './policy-info.actions';

export interface State {
  loading: boolean;
  /** Termo do tipo aberto no editor (um por vez). */
  policy: SportCenterPolicy | null;
  /** Catálogo: todos os termos do CE, um por tipo, inclusive desativados. */
  catalog: SportCenterPolicy[];
  /** Tipos que o CE pode cadastrar, com rótulo. */
  types: TermsTypeOption[];
  catalogLoading: boolean;
  error: any | null;
}

export const initialState: State = {
  loading: false,
  policy: null,
  catalog: [],
  types: [],
  catalogLoading: false,
  error: null,
};

/** Substitui (ou insere) o termo do mesmo tipo no catálogo — evita refetch após salvar/desativar. */
function upsert(catalog: SportCenterPolicy[], policy: SportCenterPolicy): SportCenterPolicy[] {
  if (!policy?.type) return catalog;
  const others = catalog.filter((t) => t.type !== policy.type);
  return [...others, policy];
}

export const reducer = createReducer(
  initialState,
  // Ao trocar de tipo, zera o termo anterior: senão o editor do tipo B
  // mostra o texto do tipo A até a resposta chegar.
  on(fromActions.fetchPolicyInfo, (state) => ({ ...state, loading: true, policy: null })),
  on(fromActions.fetchPolicyInfoSuccefully, (state, { sportCenterPolicy }) => ({
    ...state,
    policy: sportCenterPolicy,
    loading: false,
  })),
  on(fromActions.fetchPolicyInfoFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(fromActions.registerPolicyInfo, (state) => ({ ...state, loading: true })),
  on(fromActions.registerPolicyInfoSuccefully, (state, { sportCenterPolicy }) => ({
    ...state,
    policy: sportCenterPolicy,
    catalog: upsert(state.catalog, sportCenterPolicy),
    loading: false,
  })),
  on(fromActions.registerPolicyInfoFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(fromActions.fetchTermsCatalog, (state) => ({ ...state, catalogLoading: true })),
  on(fromActions.fetchTermsCatalogSuccefully, (state, { terms, types }) => ({
    ...state,
    catalog: terms,
    types,
    catalogLoading: false,
  })),
  on(fromActions.fetchTermsCatalogFailed, (state, { error }) => ({
    ...state,
    error,
    catalogLoading: false,
  })),

  on(fromActions.deactivateTerm, (state) => ({ ...state, loading: true })),
  on(fromActions.deactivateTermSuccefully, (state, { sportCenterPolicy }) => ({
    ...state,
    policy: state.policy?.type === sportCenterPolicy.type ? sportCenterPolicy : state.policy,
    catalog: upsert(state.catalog, sportCenterPolicy),
    loading: false,
  })),
  on(fromActions.deactivateTermFailed, (state, { error }) => ({ ...state, error, loading: false }))
);
